/**
 * Purpose: Board view screen — displays the classroom grid after answering a question.
 * Owns: Route handler for /board, delegates rendering to ClassroomView.
 * Notes: Previously rendered a winding BoardPath; now shows the top-down classroom
 *        desk grid via ClassroomView. Route path is unchanged (/board).
 *        Handles navigation back to /play when the user taps "Next Turn".
 */

import { useNavigate } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { ClassroomView } from '../components/classroom/ClassroomView';

export function BoardPage() {
  const navigate = useNavigate();
  const { state, nextTurn } = useGame();

  const wasCorrect = state.currentTurn.wasCorrect;
  const pointsEarned = state.currentTurn.pointsEarned;

  function handleNextTurn() {
    nextTurn();
    navigate('/play');
  }

  return (
    <ClassroomView
      onNextTurn={handleNextTurn}
      wasCorrect={wasCorrect}
      pointsEarned={pointsEarned}
    />
  );
}
